import { SnomedItem } from '../../models/Entities/Snomed/SnomedModels';
import { ErrorType } from '../../models/HttpError';

export interface SnomedState {
    isSearching: boolean;
    searchResults: SnomedItem[];
    searchTerm: string;
    error?: ErrorType;
}

export const SnomedUnloadState: SnomedState = {
    isSearching: false,
    searchResults: [],
    searchTerm: '',
    error: undefined
};
